export const SUBSCRIBE_MODAL_TITLE = 'Subscribe to new updates';

export const SUBSCRIBE_MODAL_SUBTITLE =
  'WFP’s Hunger Monitoring Unit produces recurrent updates, information, newsletters and snapshots. Add your details below to stay in touch and receive the latest news.';

export const SUBSCRIBE = 'Subscribe';

export const MANDATORY = '*Mandatory fields';

export const FOLLOW_US = 'Follow us on: ';

export const SUCCESSFUL_SUBSCRIPTION = 'Successfully subscribed!';

export const UNSUCCESSFUL_SUBSCRIPTION = 'Subscribed failed. Please try again later.';

export const CLICK_TO_SELECT = 'Topics*';

export const SELECTED_TOPICS = 'Selected topics';

export const TOPIC_MANDATORY_MSG = 'Please select at least one topic';

export const ORGANISATION_MANADATORY_MSG = 'Please enter your organisation name';

export const EMAIL_MANDATORY_MSG = 'Please enter a valid email address';

export const NAME_MANDATORY_MSG = 'Please enter your name';

export const DOWNLOAD_DATA = 'Download Data';
